import { render, staticRenderFns } from "./EmbedFooter.vue?vue&type=template&id=a55946f8&scoped=true"
import script from "./EmbedFooter.vue?vue&type=script&lang=js"
export * from "./EmbedFooter.vue?vue&type=script&lang=js"
import style0 from "./EmbedFooter.css?vue&type=style&index=0&id=a55946f8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55946f8",
  null
  
)

export default component.exports